"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleJobsFactory = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const DictionaryEvidence = __importStar(require("../../../composite/evidence-2/dictionary-evidence/dictionary-evidence"));
const evidence_1 = require("../../../composite/evidence-2/evidence");
const jobs_fields_1 = require("./jobs-fields");
const jobs_columns_1 = require("./jobs-columns");
const jobs_schema_1 = require("./jobs-schema");
const jobs_toolbar_1 = require("./jobs-toolbar");
const schedule_context_1 = require("../schedule-context");
function scheduleJobsFactory(reportTag, defaultSorts) {
    return function Jobs() {
        const intl = react_intl_1.useIntl();
        const validationSchema = jobs_schema_1.useValidationSchema();
        const { jobUrl: url } = react_1.useContext(schedule_context_1.ScheduleContext);
        const JobsToolbar = react_1.useMemo(() => jobs_toolbar_1.jobsToolbarFactory({}), []);
        const evidence = DictionaryEvidence.useDictionaryEvidence({
            version: 3,
            identifier: 'SCHEDULE_JOBS',
            apiProps: {
                url,
            },
            tableProps: {
                columns: jobs_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_TABLE_TITLE',
                    defaultMessage: 'Časové úlohy',
                }),
                reportTag,
                defaultSorts,
            },
            detailProps: {
                toolbarProps: {
                    title: intl.formatMessage({
                        id: 'EAS_SCHEDULE_JOBS_DETAIL_TITLE',
                        defaultMessage: 'Časová úloha',
                    }),
                    after: react_1.default.createElement(JobsToolbar, null),
                },
                FieldsComponent: jobs_fields_1.JobsFields,
                validationSchema,
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.scheduleJobsFactory = scheduleJobsFactory;
scheduleJobsFactory.useColumns = jobs_columns_1.useColumns;
scheduleJobsFactory.Fields = jobs_fields_1.JobsFields;
scheduleJobsFactory.useValidationSchema = jobs_schema_1.useValidationSchema;
scheduleJobsFactory.detailToolbarFactory = jobs_toolbar_1.jobsToolbarFactory;
//# sourceMappingURL=jobs.js.map